export default "__VITE_ASSET__CfBTdUlB__"